import MyLocale from '@/models/MyLocale.model';

export const hr = new MyLocale({
	title: 'WB-CPP',

	word: {
		to: 'do',
	},
	message: {
    emptyState: {
      noData: {
        title: 'Nema podataka!',
        message: 'Nema podataka!',
      },
      unknownAuthor: {
        title: 'Nepoznat autor!',
        message: 'Nepoznat autor!',
      },
    },
	},
	filters: {
		dataType: {
			title: 'Klimatski uvidi po izvoru podataka',
      info: 'Istražite opažene podatke i scenarije temeljene na modelu za ključne klimatske varijable.',
			observation: {
				title: 'Povijesno',
			},
			scenario: {
				title: 'Scenarij',
			},
      mapInfoTitle: 'Skup podataka',
		},
		variable: {
			title: 'Varijable',

			// Nove varijable
			cdd5: 'cdd5',
			cdd7: 'cdd7',
			dhi5: 'dhi5',
			dhi7: 'dhi7',
			ews: 'ews',
			ewc: 'ewc',
			ftd: 'ftd',
			hd30: 'hd30',
			hd40: 'hd40',
			ls: 'ls',
			sdii: 'sdii',
			hs: 'hs',
			sd: 'sd',
			pr: 'pr',
			tmean: 'tmean',
			tasmax: 'tasmax',
			tasmin: 'tasmin',

			// Opisi (tooltip) za nove varijable
			cdd5Tooltip: 'cdd5',
			cdd7Tooltip: 'cdd7',
			dhi5Tooltip: 'dhi5',
			dhi7Tooltip: 'dhi7',
			ewsTooltip: 'ews',
			ewcTooltip: 'ewc',
			ftdTooltip: 'ftd',
			hd30Tooltip: 'hd30',
			hd40Tooltip: 'hd40',
			lsTooltip: 'ls',
			sdiiTooltip: 'sdii',
			hsTooltip: 'hs',
			sdTooltip: 'sd',
			prTooltip: 'pr',
			tmeanTooltip: 'tmean',
			tasmaxTooltip: 'tasmax',
			tasminTooltip: 'tasmin',

			// Naslovi za nove varijable
      cdd5Title: 'Sušna razdoblja (5 dana)',
      cdd7Title: 'Sušna razdoblja (7 dana)',
      dhi5Title: 'Vrući dani u sušnim razdobljima (5 dana)',
      dhi7Title: 'Vrući dani u sušnim razdobljima (7 dana)',
      ewsTitle: 'Ekstremi brzine vjetra',
      ewcTitle: 'Dani s prekoračenjem ekstremne brzine vjetra',
      ftdTitle: 'Ciklusi smrzavanja i odmrzavanja',
      hd30Title: 'Vrući dani (30 °C)',
      hd40Title: 'Vrlo vrući dani (40 °C)',
      lsTitle: 'Kritični uvjeti oborina za klizišta',
      sdiiTitle: 'Ekstremi oborina',
      hsTitle: 'Obilne snježne padaline',
      sdTitle: 'Snježne padaline',
      prTitle: 'Količina oborina',
      tmeanTitle: 'Srednja temperatura',
      tasmaxTitle: 'Maksimalna temperatura',
      tasminTitle: 'Minimalna temperatura',

      cdd5Description: 'Dani u uzastopnim 5-dnevnim razdobljima s manje od 1 mm oborina tijekom travnja–rujna',
      cdd7Description: 'Dani u uzastopnim 7-dnevnim razdobljima s manje od 1 mm oborina tijekom travnja–rujna',
      dhi5Description: 'Dani u 5-dnevnim sušnim razdobljima s prekoračenjem 30 °C maksimalne dnevne temperature',
      dhi7Description: 'Dani u 7-dnevnim sušnim razdobljima s prekoračenjem 30 °C maksimalne dnevne temperature',
      ewsDescription: '99.9. percentil dnevnih srednjih brzina vjetra u razdoblju promatranja 1981.–2010.',
      ewcDescription: 'Dani s prekoračenjem 99.9. percentila dnevnih srednjih brzina vjetra u razdoblju promatranja 1981.–2010.',
      ftdDescription: 'Dani s minimalnom temperaturom ispod -2.2 °C i maksimalnom temperaturom iznad 0 °C',
      hd30Description: 'Dani s maksimalnom temperaturom iznad 30 °C',
      hd40Description: 'Dani s maksimalnom temperaturom iznad 40 °C',
      lsDescription: 'Dani s prekoračenjem intenziteta oborina prema Moser-Hohensinn metodi (M = 41.66 * (h-0.77) * h) za h = 24, 48 i 72 sata',
      sdiiDescription: '99.9. percentil dnevnih količina oborina unutar 30-godišnjih razdoblja',
      hsDescription: 'Dani s količinom oborina iznad 10 mm i srednjom temperaturom ispod 0 °C',
      sdDescription: 'Dani s količinom oborina iznad 1 mm i srednjom temperaturom ispod 0 °C',
      prDescription: 'Dnevna količina oborina',
      tmeanDescription: 'Dnevna srednja temperatura zraka',
      tasmaxDescription: 'Dnevna maksimalna temperatura zraka',
      tasminDescription: 'Dnevna minimalna temperatura zraka',

		},
		period: {
			title: 'Razdoblje',
      '1981-2010': '1981-2010',
      '2011-2040': '2011-2040',
      '2001-2020': '2001-2020',
      '2036-2065': '2036-2065',
      '2071-2100': '2071-2100',
		},
    scenario: {
      title: 'Scenarij',
      ens: 'ENS',
      rcp26: 'RCP2.6 (scenarij niskih emisija)',
      rcp45: 'RCP4.5 (scenarij umjerenih emisija)',
      rcp85: 'RCP8.5 (scenarij visokih emisija)',
    },
		season: {
			title: 'Sezona',
      'yr': 'Godišnje',
      '01': 'Siječanj',
      '02': 'Veljača',
      '03': 'Ožujak',
      '04': 'Travanj',
      '05': 'Svibanj',
      '06': 'Lipanj',
      '07': 'Srpanj',
      '08': 'Kolovoz',
      '09': 'Rujan',
      '10': 'Listopad',
      '11': 'Studeni',
      '12': 'Prosinac',
		},
		gwl: {
			title: 'Razina globalnog zatopljenja',
      '1.5': 'GWL1.5',
      '2.0': 'GWL2.0',
      '3.0': 'GWL3.0',
      '4.0': 'GWL4.0',
		},
		gridSpacing: {
			title: 'Razmak mreže',
      '01deg': '01deg',
		},
		author: {
      title: 'Autor',
      defaultLabel: 'Odaberite autora',
    }
	},
	options: {
		download: {
			image: 'Slika',
			pdf: 'PDF',
			file: 'Datoteka',
		},
	},
	legend: {
		min: 'min',
		max: 'maks',
	},
	mapDetails: {
		value: 'Vrijednost',

		ens: 'Medijan',
		ens75: '75. percentil',
		ens25: '25. percentil',

    noCsvData: 'Nema CSV podataka za ovu točku',
    subgridToggleLabel: 'Prikaži 30arcsec mrežu',
    subgridToggleOnInfo: 'Omogućavanje 30arcsec mreže za ovu ćeliju također će prikazati 30arcsec mrežu za sve susjedne ćelije.',
    subgridToggleOffInfo: 'Odaberite 30arcsec ćeliju za pregled njezinih podataka.',
	},
	tour: {
		closeButton: 'Zatvori',
		backButton: 'Natrag',
		nextButton: 'Sljedeće',
		completeButton: 'Završi',
		startButton: 'Započni tur kroz platformu',
	},
	unit: {
		Celsius: '°C',
		'%': '%',
		mm: 'mm',
    d: 'd',
    'm s-1': 'm s-1',
	},
  mapView: {
    noneValue: 'Bez mape',
    terrain: 'Reljef',
    satellite: 'Satelit',
  },
  mapOptions: {
    showClimateData: 'Prikaži klimatske podatke',
  },
  footer: {
    kosovoBorderLabel: 'Ova oznaka ne prejudicira stajališta o statusu i u skladu je s UNSCR 1244/99.',
  },
  nav: {
    map: 'Mapa',
  },
});
